<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import notify from "../../../../Script/notify"

  export let givenEmail
  export let domineName = ""

  /**
   * @type {Boolean} whether to show passcode enter area are not
   */
  let toggleBtn = false

  /**
   * @type {String} decide to add full email or domain
   */
  let emailType = "specificEmail"

  /**
   * @type {Array} it cotains full email values
   */
  let emailList = []

  /**
   * @type {emailNotify}
   */
  let emailNotify = {
    close() {},
  }

  /**
   * @type {RegExp} regex pattern for validating the email address
   */
  const emailAddressPattern = /^[A-Z0-9.!#$%&'+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i
  // /^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+)*$/i

  /**
   * @type {RegExp} regex pattern for validating the email address
   */
  const domainPattern = /^[A-Z0-9-]+(?:\.[A-Z0-9-]+)$/i
  //    /[A-Z0-9-]+(?:\.[A-Z0-9-]+)*$/i

  /**
   * @type {String} - confirmed domaim name
   */
  let givenDomineName = ""
  /**
   * @description Function for add and sent the full email to array
   */
  const addEmail = async () => {
    emailNotify.close()
    for (let i = 0; i < emailList.length; i++) {
      if (emailList[i] == givenEmail) {
        emailNotify = notify.info(`${givenEmail} already exist`)
        givenEmail = ""
        return
      }
    }
    if (givenEmail) {
      givenEmail = givenEmail.trim()
      if (!emailAddressPattern.test(givenEmail)) {
        const info = "PAGE: Secure Access\nEVENT: While adding invalid email address."
        emailNotify = notify.danger("Enter Valid Email address", info)
        return
      } else {
        if (emailList.length <= 10) {
          emailList = [...emailList, givenEmail]
          givenEmail = ""
          domineName = ""
          givenDomineName = ""
          notify.success("Email successfully added to the list")
          dispatch("output", emailList)
        } else {
          emailNotify = notify.info("Only 10 email IDs are allowed")
          return
        }
      }
    }
  }

  /**
   * @description Function for sent the email domain
   */
  const addDomain = async () => {
    emailNotify.close()
    domineName = domineName.trim()
    if (domineName) {
      if (!domainPattern.test(domineName)) {
        domineName = ""
        const info = "PAGE: Secure Access\nEVENT: While adding invalid domain name."
        emailNotify = notify.danger("Enter Valid domain name. example (print2block.com)", info)
        return
      } else {
        givenEmail = ""
        emailList = []
      }
    }
    givenDomineName = domineName
    dispatch("output", domineName)
  }
</script>

<div class="group space-y-3">
  <button on:click={() => (toggleBtn = !toggleBtn)} class="flex w-full items-center justify-between {emailList.length || domainPattern.test(givenDomineName.trim()) ? 'bg-green-500' : toggleBtn ? 'bg-[#09f6e7]/50' : 'bg-slate-200  hover:bg-[#09f6e7]/50 dark:bg-[#212539] dark:hover:bg-[#09f6e7]/50'} rounded-md px-3 py-2 text-[#292a23] dark:text-[#09f6e7] sm:px-6 sm:py-4">
    <div class="flex select-none {emailList.length || toggleBtn || domainPattern.test(givenDomineName.trim()) ? 'text-white' : ''} items-center gap-3 text-sm font-semibold group-hover:text-white mobile:text-base">
      <i class="fa-solid fa-envelope hidden mobile:block" />
      <p>Secure by Email</p>
    </div>
    <div class="flex items-center gap-3">
      {#if emailList.length || domineName}
        <div class="text-base text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-check" />
        </div>
      {:else}
        <div class="text-base {toggleBtn ? 'text-white' : 'text-[#292a2f] dark:text-[#09f6e7]'} group-hover:text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-exclamation" />
        </div>
      {/if}
      <!-- <ToggleSwitch bind:toggleBtn disable={emailList.length || domineList.length} /> -->
    </div>
  </button>
  {#if toggleBtn}
    <div class="space-y-3 rounded-md p-3 shadow-md dark:bg-bodyblack mobile:p-6">
      <p class="select-none text-justify text-gray-800 dark:text-gray-200">Here you can secure the document by Email</p>
      <div class="flex flex-col gap-3 mobile:flex-row mobile:gap-6">
        <button class="flex cursor-pointer items-start gap-1">
          <input bind:group={emailType} type="radio" id="specificEmail" name="specific_Email" value="specificEmail" class="mt-1 cursor-pointer" />
          <label for="specificEmail" class="{emailType == 'specificEmail' ? 'text-blue-500' : 'text-gray-200'} cursor-pointer select-none text-sm sm:text-base">Specific Email Verification</label>
        </button>
        <button class="flex cursor-pointer items-start gap-1">
          <input bind:group={emailType} type="radio" id="anyEmail" name="any_Email" value="anyEmail" class="mt-1 cursor-pointer" />
          <label for="anyEmail" class="{emailType == 'anyEmail' ? 'text-blue-500' : 'text-gray-200'} cursor-pointer select-none text-sm sm:text-base">Any Email (by Domain) Verification</label>
        </button>
      </div>
      {#if emailType == "specificEmail"}
        <form on:submit|preventDefault|stopPropagation={addEmail} class={emailList.length ? "space-y-3" : ""}>
          <div class="relative flex w-full gap-3 sm:w-1/2">
            <input on:blur={addEmail} bind:value={givenEmail} placeholder="xxxxxx@yourdomain.com" type="text" name="givenEmail" class="h-[37.6px] w-full rounded-md border border-[#a0a1a533] bg-transparent px-3 pl-5 pr-8 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
            <!-- <button disabled={!givenEmail} type="submit" class=" text-blue-500 hover:text-blue-500 active:text-blue-400 dark:hover:text-white">
              <i class="fa-solid fa-circle-plus fa-lg" />
            </button> -->

            <button disabled={!givenEmail} type="submit" class="flex h-9 w-1/2 cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
              <i class="fa-solid fa-circle-plus fa-lg" />
              &nbsp;&nbspAdd
            </button>
          </div>
          <div class="max-h-[200px] w-full space-y-1 overflow-auto sm:w-1/2">
            {#each emailList as email}
              <div class="flex w-full items-center justify-between truncate rounded-md bg-[#e9e9e9] px-3 py-2 dark:bg-mdGray dark:text-gray-200">
                <p class="truncate text-xs sm:text-base">{email}</p>
                <button
                  on:click|preventDefault={() => {
                    emailList = emailList.filter((emails) => email != emails)
                    dispatch("output", emailList)
                    return emailList
                  }}
                  class="text-red-500 hover:text-red-600 active:text-red-400"
                >
                  <i class="fa-solid fa-circle-xmark" />
                </button>
              </div>
            {/each}
          </div>
        </form>
      {:else}
        <form on:submit|preventDefault|stopPropagation={addDomain} class="w-full space-y-3 sm:w-1/2">
          <!-- <div class="relative w-full sm:w-1/2"> -->
          {#if !givenDomineName}
            <div class="flex w-full gap-3">
              <!-- bind:value={domineName} -->
              <input placeholder="yourdomain.com" bind:value={domineName} on:blur={addDomain} type="text" name="domineName" class="h-[37.6px] w-full rounded-md border border-[#a0a1a533] bg-transparent px-3 pl-5 pr-8 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />

              <button disabled={!domineName} type="submit" class="flex h-9 w-1/2 cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
                <i class="fa-solid fa-circle-plus fa-lg" />
                &nbsp;&nbspAdd
              </button>
            </div>
          {:else}
            <div class="flex w-full items-center justify-between truncate rounded-md bg-[#e9e9e9] px-3 py-2 dark:bg-mdGray dark:text-gray-200">
              <p class="truncate text-xs sm:text-base">{domineName}</p>
              <button
                on:click|preventDefault={() => {
                  domineName = ""
                  givenDomineName = ""
                  dispatch("output", "")
                }}
                class="text-red-500 hover:text-red-600 active:text-red-400"
              >
                <i class="fa-solid fa-circle-xmark" />
              </button>
            </div>
          {/if}
          <!-- <button disabled={!domineName} type="submit" class="absolute right-3 top-2 text-blue-500 hover:text-blue-600 active:text-blue-400">
              <i class="fa-solid fa-circle-plus" />
            </button>
          </div> -->
          <!-- {#each domineList as domain}
            <div class="flex w-full items-center justify-between rounded-md bg-[#f7f7f7] px-3 py-2 sm:w-1/2">
              <p class="text-xs sm:text-base">{domain}</p>
              <button
                on:click|preventDefault={() => {
                  domineList = domineList.filter((domines) => domain != domines)
                  return domineList
                }}
                class="text-red-500 hover:text-red-600 active:text-red-400"
              >
                <i class="fa-solid fa-circle-xmark" />
              </button>
            </div>
          {/each} -->
        </form>
      {/if}
    </div>
  {/if}
</div>
